import { render, staticRenderFns } from "./content-top-header.vue?vue&type=template&id=cd21a31c&scoped=true&"
import script from "./content-top-header.vue?vue&type=script&lang=js&"
export * from "./content-top-header.vue?vue&type=script&lang=js&"
import style0 from "./content-top-header.vue?vue&type=style&index=0&id=cd21a31c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd21a31c",
  null
  
)

export default component.exports